"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uniqNights = exports.isFlexNights = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var isFlexNights = exports.isFlexNights = function isFlexNights(_ref) {
  var from = _ref.from,
    to = _ref.to;
  return from !== to;
};
var uniqNights = exports.uniqNights = function uniqNights(_ref2) {
  var from = _ref2.from,
    to = _ref2.to;
  var uniq = new Set([from, to]);
  return (0, _toConsumableArray2["default"])(uniq);
};